import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import AppointmentsSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/appointments'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_appointments',
          meta: {
            // Cadastro do modulo e coisa de administrador; a marcacao do dia a
            // dia acontece na Agenda, disponivel para o agente.
            permissions: ['administrator'],
            featureModule: 'appointments',
          },
          component: AppointmentsSettings,
        },
      ],
    },
  ],
};
